import { BikeModel } from '../BikeModel';

export class RelocationReportModel {
  constructor(data) {
    data = data || {};
    this.zones = (data.zones || []).map(zone => ({
      ...zone,
      bikes: (zone.bikes || []).map(bike => new BikeModel(bike)),
    }));
    this.bikesOutsideZones = (data.bikesOutsideZones || []).map(bike => new BikeModel(bike));
    this.bikesOutsideZonesCount = data.bikesOutsideZonesCount || 0;
    this.enabledElectricBikesOutsideZonesCount = data.enabledElectricBikesOutsideZonesCount || 0;
    this.enabledStandardBikesOutsideZonesCount = data.enabledStandardBikesOutsideZonesCount || 0;
    this.disabledBikesOutsideZonesCount = data.disabledBikesOutsideZonesCount || 0;
    this.disabledElectricBikesOutsideZonesCount = data.disabledElectricBikesOutsideZonesCount || 0;
    this.disabledStandardBikesOutsideZonesCount = data.disabledStandardBikesOutsideZonesCount || 0;
  }
}
